
import React from 'react';
import { Button } from '@/components/ui/button';
import { useChatContext } from './ChatContext';
import { Sparkle } from 'lucide-react';

export const ChatToggle: React.FC = () => {
  const {
    isChatOpen,
    toggleChat
  } = useChatContext();
  return <div className="fixed bottom-6 right-5 z-50">
      <Button onClick={toggleChat} aria-label={isChatOpen ? "Close chat" : "Open chat"} 
        className={`group flex items-center justify-center flex-col gap-0 border-2 border-heaven-gold h-[4.5rem] w-[4.5rem] rounded-full shadow-md transition-all hover:border-heaven-dark-gold p-1.5 md:h-[4.5rem] md:w-[4.5rem] ${isChatOpen ? 'bg-[#34495E]' : 'hover:bg-[#34495E]'}`}
        style={{
          boxShadow: '0 4px 20px 0 rgba(52,73,94,0.12)',
          background: isChatOpen ? '#34495E' : 'linear-gradient(to bottom right, #33C3F0, #0EA5E9)'
        }}
      >
        <Sparkle className={`h-3 w-3 mb-0.5 py-0 my-0 mx-[143px] text-white ${isChatOpen ? 'text-white' : 'group-hover:text-white group-active:text-white'}`} />
        <span className="text-xs font-semibold select-none whitespace-nowrap text-white text-[0.65rem]">
          Ask Selah
        </span>
    </Button>
    </div>;
};
